
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/resources/mcp",
      function () {
        return require("private-next-pages/docs/resources/mcp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/resources/mcp"])
      });
    }
  